import React from "react";

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  message: string;
  onStay: () => void;
  onLeaveWithoutSaving: () => void;
  onSaveAndLeave?: () => void;
  isSaveAndLeavePending?: boolean;
  disableActions?: boolean;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  isOpen,
  message,
  onStay,
  onLeaveWithoutSaving,
  onSaveAndLeave,
  isSaveAndLeavePending = false,
  disableActions = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const disableSecondaryActions = disableActions || isSaveAndLeavePending;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-6 shadow-xl dark:border-gray-800 dark:bg-gray-900">
        <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Unsaved changes
        </h4>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          {message}
        </p>
        <div className="mt-5 flex justify-end gap-3">
          {onSaveAndLeave && (
            <button
              type="button"
              onClick={onSaveAndLeave}
              disabled={disableActions}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
            >
              {isSaveAndLeavePending ? "Saving..." : "Save & leave"}
            </button>
          )}
          <button
            type="button"
            onClick={onStay}
            disabled={disableSecondaryActions}
            className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            Stay
          </button>
          <button
            type="button"
            onClick={onLeaveWithoutSaving}
            disabled={disableSecondaryActions}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Leave without saving
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesDialog;
